// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login #map {
    z-index: -1;
}

.login .opacidade {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 0;
    position: fixed;
    font-size: 0;
}

.login .logo-emabrapa {
    color: #000;
}

.login .container {
    background: linear-gradient(150deg, #fff 0%, #afafaf 100%);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width: 400px;
    height: 550px;
    position: fixed;
    top: clamp(0px, calc(100dvh - 550px), 13dvh);
    margin-left: clamp(calc(100% / 2 - 200px), calc(100% - 420px), 55%);;

    box-shadow: 0px 1px 10px black;
}

.login .container h4 {
    font-family: 'Roboto Slab';
    font-weight: 500;
    margin-top: 40px;
    font-size: 15px;
    color: #1A1A1D;
    background-color: transparent;
}

.login .loginInput {
    display: flex;
    align-items: center;
    color: #000;
    background-color: #f0f0f0;
    border-radius: 5px;
    margin: 3px;

    width: 98%;
    height: 50px;
}

.login .loginInput svg {
    margin-left: 10px;
    font-size: 25px;
}

.login .loginInput input {
    background: transparent;
    width: 100%;
    outline-width: 0;
    color: #000;
    border: none;
    font-size: 17px;
    padding-left: 10px;
    padding-right: 10px;
}

.login .btn {
    width: 98%;
    background-color: #202024;
    color: #EFF2F5;
    font-weight: 800;
    height: 40px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 2px;
    margin-bottom: 2px;
    border: none;
    text-align: center;
    padding: 7px;
    text-decoration: none;

    outline-width: 0;
}

.login .btn:hover {
    background-color: #121214;
    cursor: pointer;
}

.login .div-central {
    width: 98%;
    text-align: center;
    padding-bottom: 10px;
}

.login .embrapaLogo {
    /* height: 100px; */
    width: 150px;
}

.login .aibaLogo {
    width: 125px;
    height: 40px;
    /* padding-left: -10px; */
}

.login .adabLogo {
    height: 75px;
    padding-right: 10px;
}

.login .logos {
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.login .form {
    width: 98%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.login .btn-form {
    width: 100%;
    background-color: #202024;
    color: #EFF2F5;
    font-weight: 800;
    height: 40px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 2px;
    border: none;
    text-align: center;
    padding: 7px;
    text-decoration: none;

    outline-width: 0;
}

.login .btn-form:hover {
    background-color: #121214;
    cursor: pointer;
}

.login .error {
    color: #F00;
    font-size: 10px;
    width: 100%;
    text-align: right;
    padding-right: 10px;
}

.login .btn-show {
    background: transparent;
    border: none;
    padding-right: 10px;
}

.login .btn-show:hover {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/Login.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,UAAU;IACV,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0DAA0D;IAC1D,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,4CAA4C;IAC5C,mEAAmE;;IAEnE,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;;IAEX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;;IAErB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;;IAErB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".login #map {\n    z-index: -1;\n}\n\n.login .opacidade {\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.2);\n    z-index: 0;\n    position: fixed;\n    font-size: 0;\n}\n\n.login .logo-emabrapa {\n    color: #000;\n}\n\n.login .container {\n    background: linear-gradient(150deg, #fff 0%, #afafaf 100%);\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    width: 400px;\n    height: 550px;\n    position: fixed;\n    top: clamp(0px, calc(100dvh - 550px), 13dvh);\n    margin-left: clamp(calc(100% / 2 - 200px), calc(100% - 420px), 55%);;\n\n    box-shadow: 0px 1px 10px black;\n}\n\n.login .container h4 {\n    font-family: 'Roboto Slab';\n    font-weight: 500;\n    margin-top: 40px;\n    font-size: 15px;\n    color: #1A1A1D;\n    background-color: transparent;\n}\n\n.login .loginInput {\n    display: flex;\n    align-items: center;\n    color: #000;\n    background-color: #f0f0f0;\n    border-radius: 5px;\n    margin: 3px;\n\n    width: 98%;\n    height: 50px;\n}\n\n.login .loginInput svg {\n    margin-left: 10px;\n    font-size: 25px;\n}\n\n.login .loginInput input {\n    background: transparent;\n    width: 100%;\n    outline-width: 0;\n    color: #000;\n    border: none;\n    font-size: 17px;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.login .btn {\n    width: 98%;\n    background-color: #202024;\n    color: #EFF2F5;\n    font-weight: 800;\n    height: 40px;\n    border-radius: 10px;\n    font-size: 16px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    border: none;\n    text-align: center;\n    padding: 7px;\n    text-decoration: none;\n\n    outline-width: 0;\n}\n\n.login .btn:hover {\n    background-color: #121214;\n    cursor: pointer;\n}\n\n.login .div-central {\n    width: 98%;\n    text-align: center;\n    padding-bottom: 10px;\n}\n\n.login .embrapaLogo {\n    /* height: 100px; */\n    width: 150px;\n}\n\n.login .aibaLogo {\n    width: 125px;\n    height: 40px;\n    /* padding-left: -10px; */\n}\n\n.login .adabLogo {\n    height: 75px;\n    padding-right: 10px;\n}\n\n.login .logos {\n    padding-top: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.login .form {\n    width: 98%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.login .btn-form {\n    width: 100%;\n    background-color: #202024;\n    color: #EFF2F5;\n    font-weight: 800;\n    height: 40px;\n    border-radius: 10px;\n    font-size: 16px;\n    margin-top: 10px;\n    margin-bottom: 2px;\n    border: none;\n    text-align: center;\n    padding: 7px;\n    text-decoration: none;\n\n    outline-width: 0;\n}\n\n.login .btn-form:hover {\n    background-color: #121214;\n    cursor: pointer;\n}\n\n.login .error {\n    color: #F00;\n    font-size: 10px;\n    width: 100%;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.login .btn-show {\n    background: transparent;\n    border: none;\n    padding-right: 10px;\n}\n\n.login .btn-show:hover {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
